import {
  Duration,
  TaskDependency,
} from '@totem/components/ticketing/ticketing';

export type ISODateTimeString = string;

export interface Template {
  id: string;
  name: string;
  ticketType: string;
  category: string;
  subCategory: string;
  services: string[];
  tasks: TemplateTasks;
  active: boolean;
  autoApply: boolean;
  createdByName: string;
  createdById: string;
  createdAt: ISODateTimeString;
  updatedByName: string;
  updatedById: string;
  updatedAt: ISODateTimeString;
}

export type TemplateTasks = TemplateTask[];

export interface TemplateTask {
  id: string;
  type: string;
  number: number;
  parent: number;
  position: number;
  dependencies: TaskDependency[];
  name: string;
  description: string;
  labels: string[];
  expectedDuration: Duration;
  dueDate: ISODateTimeString | null;
  assignedResources: string[];
  status: string;
  budgetedHours: number;
  billingType: string;
  isBillingMilestone: boolean;
  createdByType: string;
  createdByName: string;
  createdById: string;
  createdAt: ISODateTimeString;
  internalOnly: boolean;
  assignees: TemplateTaskDefaultAssignee[];
}

export const ASSIGNEE_TYPE_BUILDING = 'BUILDING';
export const ASSIGNEE_TYPE_ORGANIZATION = 'ORGANIZATION';
export const ASSIGNEE_TYPE_GLOBAL = 'GLOBAL';
export const ASSIGNEE_TYPE_DEPARTMENT_LEAD = 'DEPARTMENT_LEAD';
export const ASSIGNEE_TYPE_DEPARTMENT = 'DEPARTMENT';
export const ASSIGNEE_TYPE_EMAIL = 'EMAIL';
// The ticket's creator, when created by a user (not a service or inbound email); no value
export const ASSIGNEE_TYPE_CREATOR = 'CREATOR';

export const ASSIGNEE_TYPES = [
  ASSIGNEE_TYPE_BUILDING,
  ASSIGNEE_TYPE_ORGANIZATION,
  ASSIGNEE_TYPE_GLOBAL,
  ASSIGNEE_TYPE_DEPARTMENT_LEAD,
  ASSIGNEE_TYPE_DEPARTMENT,
  ASSIGNEE_TYPE_EMAIL,
  ASSIGNEE_TYPE_CREATOR,
];

export const ASSIGNEE_TYPE_LABELS: Record<string, string> = {
  [ASSIGNEE_TYPE_BUILDING]: 'Building Contact',
  [ASSIGNEE_TYPE_ORGANIZATION]: 'Organization Contact',
  [ASSIGNEE_TYPE_GLOBAL]: 'Global Contact',
  [ASSIGNEE_TYPE_DEPARTMENT_LEAD]: 'Department Lead',
  [ASSIGNEE_TYPE_DEPARTMENT]: 'Department',
  [ASSIGNEE_TYPE_EMAIL]: 'Email',
  [ASSIGNEE_TYPE_CREATOR]: 'Ticket Creator',
};

export interface TemplateTaskDefaultAssignee {
  type: string;
  assignee: string; // Email address, contact label, or department code depending on "type"
}

export interface TemplateTaskAssigneeOptions {
  building: string[];
  organization: string[];
  global: string[];
  departments: string[];
}
